// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"b74d0b06","453":"d6087ebb","948":"ff87896d"}[chunkId] + ".chunk.js";
};